import { } from "helpers/url_helper";
import {
  POST_ON_CALL_POLICY, POST_ON_CALL_POLICY_FAIL, POST_ON_CALL_POLICY_SUCCESS, GET_ON_CALL_POLICY_SUCCESS, GET_ON_CALL_POLICY_FAIL, GET_ON_CALL_POLICY, GET_SPECIFIC_ON_CALL_POLICY, GET_SPECIFIC_ON_CALL_POLICY_FAIL, GET_SPECIFIC_ON_CALL_POLICY_SUCCESS, EDIT_ON_CALL_POLICY_SUCCESS, EDIT_ON_CALL_POLICY_FAIL, EDIT_ON_CALL_POLICY, DELETE_SPECIFIC_ON_CALL_POLICY_SUCCESS, DELETE_SPECIFIC_ON_CALL_POLICY_FAIL, DELETE_SPECIFIC_ON_CALL_POLICY, GET_ONCALL_ELIGIBLE_USERS_SUCCESS, GET_ONCALL_ELIGIBLE_USERS_FAIL, GET_ONCALL_ELIGIBLE_USERS
} from "./actionTypes";

export const getOnCallPolicies = () => ({
  type: GET_ON_CALL_POLICY,
})

export const getOnCallPoliciesSuccess = policies => ({
  type: GET_ON_CALL_POLICY_SUCCESS,
  payload: policies,
})

export const getOnCallPoliciesFail = error => ({
  type: GET_ON_CALL_POLICY_FAIL,
  payload: error,
})

export const getSpecificOnCallPolicy = data => ({
  type: GET_SPECIFIC_ON_CALL_POLICY,
  payload: data
})

export const getSpecificOnCallPolicySuccess = specific_policy => ({
  type: GET_SPECIFIC_ON_CALL_POLICY_SUCCESS,
  payload: specific_policy,
})

export const getSpecificOnCallPolicyFail = error => ({
  type: GET_SPECIFIC_ON_CALL_POLICY_FAIL,
  payload: error,
})

export const deleteSpecificOnCallPolicy = (oncall_policy_id) => ({
  type: DELETE_SPECIFIC_ON_CALL_POLICY,
  payload: { oncall_policy_id }
})

export const deleteSpecificOnCallPolicySuccess = policy_deleted => ({
  type: DELETE_SPECIFIC_ON_CALL_POLICY_SUCCESS,
  payload: policy_deleted,
})

export const deleteSpecificOnCallPolicyFail = error => ({
  type: DELETE_SPECIFIC_ON_CALL_POLICY_FAIL,
  payload: error,
})

export const postOnCallPolicy = (name, timezone,repeat_escalation_policy, rotation_list) => {
  return {
    type: POST_ON_CALL_POLICY,
    payload: { name, timezone,repeat_escalation_policy, rotation_list },
  }
}

export const postOnCallPolicySuccess = policy => ({
  type: POST_ON_CALL_POLICY_SUCCESS,
  payload: policy,
})

export const postOnCallPolicyFail = error => ({
  type: POST_ON_CALL_POLICY_FAIL,
  payload: error,
})

export const editOnCallPolicy = (oncall_policy_id, name, timezone,repeat_escalation_policy, rotation_list, rotationsToBeDeleted) => {
  return {
    type: EDIT_ON_CALL_POLICY,
    payload: { oncall_policy_id, name, timezone,repeat_escalation_policy, rotation_list,rotationsToBeDeleted },
  }
}

export const editOnCallPolicySuccess = modified_policy => ({
  type: EDIT_ON_CALL_POLICY_SUCCESS,
  payload: modified_policy,
})

export const editOnCallPolicyFail = error => ({
  type: EDIT_ON_CALL_POLICY_FAIL,
  payload: error,
})

export const getOncallEligibleUsers = () => ({
  type: GET_ONCALL_ELIGIBLE_USERS,
})

export const getOncallEligibleUsersSuccess = eligibleUsers => ({
  type: GET_ONCALL_ELIGIBLE_USERS_SUCCESS,
  payload: eligibleUsers,
})

export const getOncallEligibleUsersFail = error => ({
  type: GET_ONCALL_ELIGIBLE_USERS_FAIL,
  payload: error,
})